import { useSelector } from 'react-redux'
import SearchForm from './search-form'

interface SearchFormProps {
  // setSearchData: React.Dispatch<any>;
  // setSelectedPolygon: React.Dispatch<any>;
  setSelectedPolygons: React.Dispatch<any>
  polygons: any
  getZoneInfo: any
  response: any
  selectedHub: any
  setSelectedHub: any
}

const SidebarContent = ({
  // setSearchData,
  // setSelectedPolygon,
  setSelectedPolygons,
  polygons,
  getZoneInfo,
  response,
  selectedHub,
  setSelectedHub,
}: SearchFormProps) => {
  return (
    <div className='custom-sidebar-optime p-2'>
      <SearchForm
        // setSearchData={setSearchData}
        // setSelectedPolygon={setSelectedPolygon}
        setSelectedPolygons={setSelectedPolygons}
        polygons={polygons}
        getZoneInfo={getZoneInfo}
        response={response}
        selectedHub={selectedHub}
        setSelectedHub={setSelectedHub}
      />
    </div>
  )
}

export default SidebarContent
